/**
 * Adressen des Kundenportals, die der Browser direkt aufruft (Link, <img>, neuer Tab): reine Funktionen ohne
 * Netzwerk und ohne Build-Konstanten, damit sie sich einzeln testen lassen.
 */

/**
 * Adresse eines Protokoll-PDFs über ein kurzlebiges Ticket (GET /portal/protocols/ticket/{ticket}).
 * In der Adresse stehen KEINE Zugangsdaten (kein Token, keine PLZ, kein Kennzeichen): das Ticket gilt 60 Sekunden
 * und ist an genau diesen Satz gebunden. So landen Zugangsdaten weder im Access-Log noch im Browserverlauf.
 */
export function buildPortalProtocolTicketUrl(baseUrl: string, ticket: string): string {
  return `${baseUrl}/portal/protocols/ticket/${encodeURIComponent(ticket)}`;
}
